module.exports = __webpack_public_path__ + "images/liinilaevad/routes/TAL-AEG-TAL@3x.png";